<div class="grid-container">
  <flame-empty-state icon="finance-purchase-currency-dollar">
    <flame-empty-state-content>
      <h2>{{labels.title}}</h2>
      <div class="fl-empty-text">
        {{ labels.dialogLabel }}
      </div>

      <button flameButton color="primary" (click)="closeDialog()"> {{ labels.bottomButton }}
      </button>
    </flame-empty-state-content>
  </flame-empty-state>
</div>